<div class="units">
  <div class="unit-selections-2 single">
    @for (competitor of competitors | orderBy:'cloth_number'; track $index; let i = $index) {
      <div class="unit-item-2 racing">
        <div class="racing-content-left">
          <div class="racecard">

          </div>
          @if (competitor.withdrawn) {
            <div class="racing-silk-preview">
              <span [transloco]="'racing.NON_RUNNER'"></span>
            </div>
          }
          <div class="breakdown-score-2">
            {{competitor.name}}
          </div>
        </div>
        <div class="breakdown-units-2">
          @if (competitor.selection.unit_distributions.length <= 0) {<span> - </span>}
          @if (competitor.selection.unit_distributions.length > 0) {
            <span class="mr-0.5">{{competitor.selection.unit_distributions[0].units | formatUnits }}</span>
            @if (competitor.selection.unit_distributions[0].units != 0) {
              <span [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
